<div class="page-root">
    <div class="breadcrumbs">
        <ng-content>
            <!-- <map-overlay-tabs [breadCrumbs]="breadCrumbs" [componentName]="componentName"></map-overlay-tabs> -->

        </ng-content>
    </div>
</div>